import React from 'react';
import classnames from 'classnames';

import { getIconsDefinitions } from './icons-definitions';
import css from '../../utils/css';

const baseClasses = css`
  .container {
    display: inline-flex;
    vertical-align: middle;
  }

  .metaIcon {
    position: absolute;
    right: -8px;
    top: -5px;
    line-height: 0;
  }
`;

export default function LucideIcon(props) {
  const {
    className,
    icon,
    size = 16,
    color,
    colorHover,
    strokeWidth = 1.75,
    fill,
    title,
    ...other
  } = props;

  const Icon = getIconsDefinitions(icon);

  const classes = css`
    .container {
      color: ${color || 'inherit'};
      line-height: 0;
      &:hover {
        color: ${colorHover || 'inherit'};
      }
    }
  `.extend(baseClasses);

  if (!Icon) return null;

  const isMetaIcon =
    className === 'meta-icon' || className?.includes?.('meta-icon');

  return (
    <span
      {...other}
      className={classnames(
        classes.container,
        isMetaIcon && baseClasses.metaIcon,
        className
      )}
      title={title}
    >
      <Icon
        size={size}
        strokeWidth={strokeWidth}
        {...(fill != null ? { fill } : {})}
      />
    </span>
  );
}
